import { Link, NavLink } from "react-router-dom";
import { SITE_NAME } from "@/lib/site";

const nav = [
  { label: "Guides", to: "/how-to-choose-a-smile-makeover-clinic-in-spain" },
  { label: "Comparisons", to: "/best-veneer-clinics-in-marbella" },
  { label: "Methodology", to: "/methodology" },
  { label: "About", to: "/about" },
];

export default function Header() {
  return (
    <header className="border-b border-rule bg-cream">
      <div className="container-wide flex flex-col gap-3 py-6 md:flex-row md:items-end md:justify-between md:py-8">
        <Link to="/" className="no-underline">
          <div className="font-serif text-[1.6rem] leading-none tracking-tight text-ink">
            {SITE_NAME}
          </div>
          <div className="mt-1 font-sans text-[0.72rem] uppercase tracking-[0.22em] text-charcoal/60">
            Editorial — Spain
          </div>
        </Link>
        <nav aria-label="Primary">
          <ul className="flex flex-wrap gap-x-6 gap-y-2 font-sans text-small">
            {nav.map((item) => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) =>
                    `no-underline tracking-wide ${
                      isActive
                        ? "text-ink"
                        : "text-charcoal/70 hover:text-ink"
                    }`
                  }
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    </header>
  );
}
